const NAV_LAYER_COLLAPSE_EXPAND_DURATION_MS = 200;
const courseRevisionEditTransitionDurationMs = 250;
const navListCls = "_61n1wrtxk7";

/**
 * Defines styles used when a navigation layer (child) is expanded/collapsed
 */
const transitionCls = "_61t13wddem";
const navItemTransitionCls = "_61ntnzcwq";

export { NAV_LAYER_COLLAPSE_EXPAND_DURATION_MS, courseRevisionEditTransitionDurationMs, navItemTransitionCls, navListCls, transitionCls };
import "./nav-layer.style.linaria.module.css";
//# sourceMappingURL=nav-layer.style.js.map
